module.exports = __webpack_public_path__ + "img/icon-badge.bf1df89a.svg";